module.exports = __webpack_public_path__ + "img/whatsApp.d39b8728.png";